'use strict';

var _ = require('lodash');
var SeasonalityEditCalendarUtilsService = function SeasonalityEditCalendarUtilsService(seasonalityConstants, dowConstants, Calendar, PooledCalendar, DowGroup, featureToggleService) {
  function mapDowGroupIDs(dowNames) {
    return _.map(dowNames, function (dowName) {
      return dowConstants.NAME_TO_ID[dowName];
    });
  }
  function convertSavedDowGroups(dowGroups) {
    return _.map(dowGroups, function (dowGroup) {
      var groupIds = mapDowGroupIDs(dowGroup.dow);
      var disabledIds = _.difference(dowConstants.ALL_DOW_IDS, groupIds);
      return new DowGroup({
        days: groupIds,
        disabledDays: disabledIds
      });
    });
  }
  function transformSpecialEvents(events) {
    return _.chain(events).map(function (event, idx) {
      var result = _.cloneDeep(event);
      result.isRowRemovable = true;
      result.isRowEditable = true;
      result.originalRowId = idx;
      return result;
    }).value();
  }
  function transformSavedCalendar(cal, isPooledCalendar) {
    var transformedCalendar = {
      markets: [cal.market],
      name: cal.calendarName,
      dateRangeFrom: cal.startDepartureDate,
      dateRangeTo: cal.endDepartureDate,
      outlierTolerance: cal.outlierTolerance,
      dowGroups: convertSavedDowGroups(cal.dowGroups),
      events: transformSpecialEvents(cal.specialEvents)
    };
    if (isPooledCalendar) {
      transformedCalendar.regressionTerms = cal.regressionTerms;
      transformedCalendar.learningProcess = cal.learningProcess;
      return transformedCalendar;
    }
    transformedCalendar.maxNumberOfSeasons = {
      id: cal.maxOptimalSeasons
    };
    transformedCalendar.minNumberOfSeasons = {
      id: cal.minOptimalSeasons
    };
    transformedCalendar.domainName = cal.domainName;
    transformedCalendar.level = cal.domainName === 'LegShowUpMetrics' && cal.seasonalityLevel === 'MARKET' ? 'Leg' : seasonalityConstants.SEASONALITY_LEVEL_TO_LEVEL[cal.seasonalityLevel];
    transformedCalendar.metric = seasonalityConstants.SEASONALITY_VARIABLE_TO_METRICS[cal.seasonalityVariable];
    transformedCalendar.minDevBetweenSeasons = cal.optimalSeasonCutoffCV;
    transformedCalendar.smoothingNumberOfWeeks = {
      id: cal.smoothingNumberOfWeeks
    };
    transformedCalendar.customDow = true;
    return transformedCalendar;
  }
  function getCalendarCopy(savedCalendarData, calendarMode) {
    if (featureToggleService.isEnabled('POOLED_SEASONALITY') && calendarMode === seasonalityConstants.CALENDAR_MODES.DEMAND) {
      return new PooledCalendar(transformSavedCalendar(savedCalendarData, true), calendarMode);
    } else {
      return new Calendar(transformSavedCalendar(savedCalendarData), calendarMode);
    }
  }
  function getNewCalendar(calendarMode) {
    var defaults = {
      dowGroups: dowConstants.ALL_DOW_IDS.map(function (id) {
        return new DowGroup({
          days: [id]
        });
      })
    };
    if (featureToggleService.isEnabled('POOLED_SEASONALITY') && calendarMode === seasonalityConstants.CALENDAR_MODES.DEMAND) {
      return new PooledCalendar(defaults);
    } else {
      return new Calendar(defaults, calendarMode);
    }
  }
  return {
    getNewCalendar: getNewCalendar,
    getCalendarCopy: getCalendarCopy
  };
};
SeasonalityEditCalendarUtilsService.$inject = ['SeasonalityConstants', 'DowConstants', 'CalendarFactory', 'PooledCalendarFactory', 'DowGroupFactory', 'FeatureToggleService'];
module.exports = SeasonalityEditCalendarUtilsService;